import { FormattedMessage } from 'react-intl'
import {PrintedMaterialsListToolbar} from './PrintedMaterialsListToolbar'

const PrintedMaterialsListHeader = () => {

  return (
    <div className='card-header border-0 pt-6'>
      <h2 className='fw-bolder'>{<FormattedMessage id ="PRINTED.MATERIALS.LIST"/>}</h2>
      {/* <ParametersListSearchComponent /> */}
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {<PrintedMaterialsListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {PrintedMaterialsListHeader}
